import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "error"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'classnames';
import { Checkbox as MaterialCheckbox } from '@material-ui/core';
import useCheckboxStyles from './Checkbox.styles';
import CheckMarkIcon from './CheckMarkIcon';
const Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  const {
      className,
      error
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const classes = useCheckboxStyles();
  return /*#__PURE__*/React.createElement(MaterialCheckbox, Object.assign({}, otherProps, {
    className: clsx(classes.root, className),
    checkedIcon: /*#__PURE__*/React.createElement("span", {
      className: clsx(classes.icon, classes.checkedIcon, {
        [classes.iconRed]: error,
        [classes.checkedIconRed]: error
      })
    }, /*#__PURE__*/React.createElement(CheckMarkIcon, {
      className: classes.checkMark
    })),
    icon: /*#__PURE__*/React.createElement("span", {
      className: clsx(classes.icon, {
        [classes.iconRed]: error
      })
    }),
    indeterminateIcon: /*#__PURE__*/React.createElement("span", {
      className: clsx(classes.icon, classes.checkedIcon, {
        [classes.iconRed]: error,
        [classes.checkedIconRed]: error
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.indeterminateIconLine
    })),
    ref: ref,
    inputProps: _objectSpread(_objectSpread({}, otherProps.inputProps), {}, {
      'data-error': error
    }),
    disableRipple: true
  }));
});
Checkbox.propTypes = {
  /**
   * Whether or not the checkbox element is checked.
   */
  checked: bool,
  /**
   * Applies additional CSS classes to the wrapper of the `Checkbox` component.
   */
  className: string,
  /**
   * Whether or not the checkbox element is available to selection.
   */
  disabled: bool,
  /**
   * Applies error state styling to the `Checkbox` component.
   */
  error: bool,
  /**
   *
   */
  id: string.isRequired,
  /**
   * Applies indeterminate state styling to the `Checkbox` component.
   */
  indeterminate: bool,
  /**
   * Whether or not the HTML input is required before a form submission can occur.
   */
  required: bool
};
Checkbox.defaultProps = {
  checked: undefined,
  className: undefined,
  disabled: undefined,
  error: undefined,
  indeterminate: undefined,
  required: undefined
};
export default Checkbox;